import { render, staticRenderFns } from "./ChatSessionSidebar.vue?vue&type=template&id=10de3eeb&scoped=true"
import script from "./ChatSessionSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSessionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatSessionSidebar.vue?vue&type=style&index=0&id=10de3eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de3eeb",
  null
  
)

export default component.exports